import { db } from "./firebase";
import {
  collection, getDocs, doc, setDoc, getDoc, serverTimestamp
} from "firebase/firestore";

const COL = "rates";

// Rate key format: email__WAREHOUSE__UNIT e.g. "john@x.com__USA__7000"
function rateKey(email, warehouse, unit) {
  return `${email.toLowerCase().trim()}__${warehouse}__${unit}`;
}

export async function getCustomerRate(email, warehouse = "USA", unit = "7000") {
  const snap = await getDoc(doc(db, COL, rateKey(email, warehouse, unit)));
  return snap.exists() ? snap.data() : null;
}

export async function getAllRates() {
  const snap = await getDocs(collection(db, COL));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function setCustomerRate(email, warehouse, unit, ratePerKg) {
  const key = rateKey(email, warehouse, unit);
  await setDoc(doc(db, COL, key), {
    email:      email.toLowerCase().trim(),
    warehouse,
    unit,
    ratePerKg:  parseFloat(ratePerKg),
    updatedAt:  serverTimestamp(),
  }, { merge: true });
}

export async function deleteRate(id) {
  const { deleteDoc } = await import("firebase/firestore");
  await deleteDoc(doc(db, COL, id));
}

export function calculateCost(weightLbs, ratePerKg) {
  const weightKg = weightLbs * 0.453592;
  return (weightKg * ratePerKg).toFixed(2);
}
